export enum AcademyColors {
	PRIMARY = 'var(--color-academy-primary)',
	PRIMARY900 = 'var(--color-academy-primary-900)',
	PRIMARY800 = 'var(--color-academy-primary-800)',
	PRIMARY700 = 'var(--color-academy-primary-700)',
	PRIMARY600 = 'var(--color-academy-primary-600)',
	PRIMARY500 = 'var(--color-academy-primary-500)',
	PRIMARY400 = 'var(--color-academy-primary-400)',
	PRIMARY300 = 'var(--color-academy-primary-300)',
	PRIMARY200 = 'var(--color-academy-primary-200)',
	PRIMARY100 = 'var(--color-academy-primary-100)',
}
